import { Box, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useBeneficiosStore } from '../store/beneficiosStore';
import CTSPanel from './CTSPanel';
import GratificacionPanel from './GratificacionPanel';
import ProvisionesPanel from './ProvisionesPanel';
import PrestamosPanel from './PrestamosPanel';
import VacacionesPanel from './VacacionesPanel';

function TabPanel({ children, value, index }: { children: React.ReactNode; value: number; index: number }) {
  return (
    <div role="tabpanel" hidden={value !== index} style={{ paddingTop: 12 }}>
      {value === index && children}
    </div>
  );
}

export default function BeneficiosPage() {
  const { activeTab, setActiveTab, error } = useBeneficiosStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
      <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ mb: 2, fontWeight: 600 }}>
        Beneficios Laborales
      </Typography>

      {error && (
        <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
      )}

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          variant={isMobile ? 'scrollable' : 'standard'}
          scrollButtons={isMobile ? 'auto' : false}
          allowScrollButtonsMobile
        >
          <Tab label="CTS" />
          <Tab label={isMobile ? 'Grat.' : 'Gratificaciones'} />
          <Tab label={isMobile ? 'Prov.' : 'Provisiones'} />
          <Tab label={isMobile ? 'Prést.' : 'Prestamos'} />
          <Tab label={isMobile ? 'Vac.' : 'Vacaciones'} />
        </Tabs>
      </Box>

      <TabPanel value={activeTab} index={0}>
        <CTSPanel />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <GratificacionPanel />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <ProvisionesPanel />
      </TabPanel>
      <TabPanel value={activeTab} index={3}>
        <PrestamosPanel />
      </TabPanel>
      <TabPanel value={activeTab} index={4}>
        <VacacionesPanel />
      </TabPanel>
    </Box>
  );
}
